<div class="test-connection-container">
  <div *ngIf="progress === WholesalerIntegrationStepsEnum.PendingConnection" class="description">
    Please complete each field below.
  </div>

  <div *ngIf="progress === WholesalerIntegrationStepsEnum.Finish" class="description">
    Click Finish below to finalize your EDI sync.
  </div>

  <app-alert [show]="showMessage"
             [autohide]="autohideDelay"
             [type]="alertMessage?.type"
             [message]="alertMessage?.text"
             (closeAlert)="showMessage = false"
  ></app-alert>

  <form [formGroup]="connectionForm" class="connection-form">
    <app-input-search-scanner formControlName="wholesalerName"
               (optionSelected)="wholesalerSelected($event)"
               (searchCleared)="wholesalerSearchCleared()"
               (searchValueChanged)="wholesalerSearchValueChanged($event)"
               [placeholder]="'Type to search a wholesaler'"
               [loading]="loading$ | async"
               [autofocus]="focusWholesalerSearch"
               [wholesalerSearch]="true"
               [label]="'Wholesaler'"
    ></app-input-search-scanner>
    <app-input [label]="'Server URL'"
               [prefix]="'sftp://'"
               formControlName="ftpUrl"
               (keydownTab)="focusInput('outputPathInput')"
               (keyupEnter)="focusInput('outputPathInput')"
               [readOnly]="autoFilledProps.ftpUrl"
               [ignoreInput]="autoFilledProps.ftpUrl"
               customClasses="!mr-0"
               [tabInd]="0"
               #serverURLInput
    ></app-input>
    <div class="form-row two-items">   
      <app-input [label]="'Folder Path'"
                 formControlName="outputPath"
                 (keydownTab)="focusDropdown('ftpPasswordInput')"
                 (keyupEnter)="focusDropdown('ftpPasswordInput')"
                 [tabInd]="0"
                 [readOnly]="autoFilledProps.outputPath"
                 [ignoreInput]="autoFilledProps.outputPath"
                 #outputPathInput
      ></app-input>
      <app-input [label]="'FTP Port'"
                formControlName="ftpPort"
                [type]="'number'"
                (keydownTab)="focusInput('ftpUsernameInput')"
                (keyupEnter)="focusInput('ftpUsernameInput')"
                [readOnly]="autoFilledProps.ftpPort"
                [ignoreInput]="autoFilledProps.ftpPort"
                [tabInd]="0"
                #ftpPortInput
    ></app-input>
  </div>
    <div class="form-row two-items">
      <app-input [label]="'FTP Username'"
                formControlName="ftpUsername"
                (keydownTab)="focusInput('ftpPasswordInput')"
                (keyupEnter)="focusInput('ftpPasswordInput')"
                [readOnly]="autoFilledProps.ftpUsername"
                [ignoreInput]="autoFilledProps.ftpUsername"
                [tabInd]="0"
                #ftpUsernameInput
      ></app-input>
      <app-input [label]="'FTP Password'"
                [type]="'password'"
                formControlName="ftpPassword"
                customClasses="!pr-10"
                (keydownTab)="focusInput('wanInput')"
                (keyupEnter)="focusInput('wanInput')"
                [readOnly]="autoFilledProps.ftpPassword"
                [ignoreInput]="autoFilledProps.ftpPassword"
                [tabInd]="0"  
                #ftpPasswordInput
      ></app-input>
    </div>
    <app-input [label]="'Wholesaler Account Number'"
               [type]="'number'"
               formControlName="accountNumber"
               (keyupEnter)="testConnection()"
               (keydownTab)="focusButton('testConnectionButton')"
               [tabInd]="0"
               #wanInput
    ></app-input>
    <app-inventory-locations-dropdown
      label="Default Inventory Location"
      [formControl]="connectionForm.controls.defaultInventoryLocationID"
    >
    </app-inventory-locations-dropdown>
  </form>

  <div *ngIf="progress === WholesalerIntegrationStepsEnum.PendingConnection" class="controls">
    <app-button customClasses="w-full"
                text="Test Connection"
                class="next"
                [disabled]="(loading$ | async)"
                (clicked)="testConnection()"
                #testConnectionButton
    >
    </app-button>

    <app-button customClasses="w-full"
                subStyle="transparent"
                class="back"
                (clicked)="back.emit(wholesaler ? WholesalerIntegrationStepsEnum.SelectType : null)"
    >
      <img class="chevron-icon" src="assets/icons/icon-chevron-down-gray.svg" alt="chevron-left-icon" />
      Back
    </app-button>
  </div>

  <div *ngIf="progress === WholesalerIntegrationStepsEnum.Finish" class="controls">
    <app-button customClasses="w-full"
                text="Finish"
                class="next"
                (clicked)="save.emit(connectionForm.value)"
                [disabled]="loading$ | async"
    >
    </app-button>
    <app-button customClasses="w-full"
                subStyle="transparent"
                class="back"
                (clicked)="backToConnection()"
    >
      <img class="chevron-icon" src="assets/icons/icon-chevron-down-gray.svg" alt="chevron-left-icon" />
      Back
    </app-button>
  </div>
</div>
